const FADE_TEXT_CHAR_LIMIT = 32;
const HORIZONTAL_ELLIPSIS_UNICODE = "\u2026";

export default function truncateText({
  text,
  limit = FADE_TEXT_CHAR_LIMIT,
  fadeToken = HORIZONTAL_ELLIPSIS_UNICODE,
  shouldTruncateOnDevice
}: {
  text: string;
  limit?: number;
  fadeToken?: string;
  shouldTruncateOnDevice: boolean;
}) {
  return text?.length > limit && shouldTruncateOnDevice
    ? text!.slice(0, limit) + fadeToken
    : text;
}
